<template>
	<div class="item page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<el-dialog title="拍卖记录" :visible="dialogVisible" @close="dialogVisible = false">
			<el-table :data="recordData" style="width: 100%" :border="true" :header-cell-style="{background:'#eaf0fa'}">
				<el-table-column label="状态" width="150" align="center">
					<template slot-scope="scope">
						<span class="auction-leader" v-if="scope.$index == 0">领先</span>
						<span class="auction-out" v-else>出局</span>
					</template>
				</el-table-column>
				<el-table-column label="竞买号" width="350" align="center">
					<template slot-scope="scope">
						<span class="auction-leader"
							v-if="scope.$index == 0 && recordConfig.currentPage == 1">{{scope.row.biddingNo}}</span>
						<span class="auction-out" v-else>{{scope.row.biddingNo}}</span>
					</template>
				</el-table-column>
				<el-table-column label="价格" width="150" align="center">
					<template slot-scope="scope">
						<span class="auction-leader" v-if="scope.$index == 0">{{scope.row.price}}</span>
						<span class="auction-out" v-else>{{scope.row.price}}</span>
					</template>
				</el-table-column>
				<el-table-column label="时间" align="center">
					<template slot-scope="scope">
						<span class="auction-leader" v-if="scope.$index == 0">{{scope.row.biddingTime}}</span>
						<span class="auction-out" v-else>{{scope.row.biddingTime}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="dialog-pager">
				<el-pagination background layout="total, prev, pager, next" :total="recordConfig.total"
					:pager-count="11" :page-size="recordConfig.pageSize" :current-page="recordConfig.currentPage"
					@current-change="recordPageChange">
				</el-pagination>
			</div>
		</el-dialog>
		<el-dialog title="藏品信息" :visible="checkFlag" @close="checkFlag = false">
			<ul class="commodity-info">
				<li><span class="key">藏品名称：</span><span class="value">{{info.lotName}}</span></li>
				<li><span class="key">藏品图片：</span><span class="value">
						<img :src="$pub.imageUrl+info.lotPictrueUrl" alt=""></span></li>
				<li><span class="key">文件大小：</span><span class="value">{{info.lotPictrueSize}}KB</span></li>
				<li><span class="key">创作完成时间：</span><span class="value">{{info.finishTime}}</span></li>
				<li><span class="key">藏品作者（发行方）：</span><span class="value">{{info.lotAuthor}}</span></li>
				<li><span class="key">藏品类别：</span><span class="value">{{info.lotOneTypeName}},{{info.lotTwoTypeName}}</span></li>
				<li><span class="key">藏品标签：</span><span class="value">{{info.lotLabel}}</span></li>
				<li><span class="key">藏品介绍：</span><span class="value" v-html="info.lotDescribe"></span></li>
				<li><span class="key">上链渠道：</span><span class="value">{{info.cochainChannel==='1'?'百度':'中经天平'}}</span>
				</li>
				<li><span class="key">区块链地址：</span><span class="value">{{info.blockchainAddress}}</span></li>
				<li><span class="key">藏品创建时间：</span><span class="value">{{info.createAt}}</span></li>
				<li><span class="key">参加活动：</span><span class="value">{{!info.activityId?'未参加活动':info.activityName}}</span></li>
				<li><span class="key">开始时间：</span><span class="value">{{info.startTime}}</span></li>
				<li><span class="key">结束时间：</span><span class="value">{{info.endTime}}</span></li>
				<li><span class="key">保证金：</span><span class="value">{{info.bond}}</span></li>
				<li><span class="key">保证金变更方式：</span><span class="value">{{info.bondType == 0 ? '不退还保证金，抵扣拍卖金额。' : '退还保证金，全额支付。'}}</span></li>
				<li><span class="key">起拍价：</span><span class="value">{{info.startPrice}}</span></li>
				<li><span class="key">当前价：</span><span class="value">{{info.currentPrice}}</span></li>
				<li><span class="key">加价幅度：</span><span class="value">{{info.priceIncreaseRange}}</span></li>
				<li><span class="key">评估价：</span><span class="value">{{info.evaluationPrice}}</span></li>
				<li><span class="key">延价周期：</span><span class="value">{{info.delayPeriod}}</span></li>
				<li><span class="key">拍品介绍：</span><span class="value" v-html="info.objectIntroduce"></span></li>
				<li><span class="key">拍卖公告：</span><span class="value" v-html="info.auctionAnnouncement"></span></li>
				<li><span class="key">拍卖资料：</span><span class="value"><a :href="info.dataUrl">{{info.dataUrl}}</a></span></li>
				<li><span class="key">报名须知：</span><span class="value" v-html="info.notice"></span></li>
				<li><span class="key">拍卖规则：</span><span class="value" v-html="info.auctionRule"></span></li>
			</ul>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'item',
		data() {
			return {
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加拍卖',
					sign: 'new'
				}],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					auctionMenu: true,
					tableHeader: [{
							prop: 'lotName',
							label: '商品名称',
							width: 300
						},
						{
							prop: 'lotAuthor',
							label: '作者',
							width: 100
						},
						{
							prop: 'lotPictrueSize',
							label: '文件大小（KB）',
							width: 130
						},
						{
							prop: 'startTime',
							label: '开始时间',
							width: 160
						},
						{
							prop: 'endTime',
							label: '结束时间',
							width: 160
						},
						{
							prop: 'lotStatus',
							label: '当前状态',
							width: 100,
							template: true
						},
						{
							prop: 'auctionStatus',
							label: '拍卖进度',
							width: 100,
							template: true
						},
						{
							prop: 'currentPrice',
							label: '当前价格',
							width: 140
						}
					],
					tableEvent: [{
							icon: 'el-icon-edit',
							name: '编辑',
							color: 'blue',
							sign: 'edit'
						}, {
							icon: 'el-icon-search',
							name: '查看',
							color: 'blue',
							sign: 'search'
						},
						{
							icon: 'el-icon-top',
							name: '上架',
							color: 'blue',
							sign: 'putaway'
						},
						{
							icon: 'el-icon-bottom',
							name: '下架',
							color: 'red',
							sign: 'soldout'
						},
						{
							icon: 'el-icon-s-order',
							name: '拍卖记录',
							color: 'blue',
							sign: 'record'
						},
						{
							icon: 'el-icon-money',
							name: '保证金记录',
							color: 'blue',
							sign: 'deposit'
						}
					],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				dialogVisible: false,
				recordConfig: {
					id: '',
					total: 0,
					pageSize: 8,
					currentPage: 1
				},
				recordData: [],
				checkFlag: false,
				info: {}
			};
		},
		methods: {
			// 页面变化
			pageChange() {
				this.fetchData()
			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'new') {
					this.$router.push({
						path: '/itemedit'
					})
				}
			},
			// 筛选条件变化
			filterChange() {
				console.log(this.filterValue);
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				if (sign == 'edit') {
					if (row.lotStatus == 1) {
						this.$message({
							message: '当前拍品已上架，不可编辑',
							type: 'error',
							duration: 2000
						})
						return
					}
					this.$router.push({
						path: '/itemedit',
						query: {
							id: row.id
						}
					})
				}
				if (sign == 'putaway') {
					if (row.lotStatus == 1) {
						this.$message({
							message: '当前拍品已上架',
							type: 'error',
							duration: 2000
						})
						return
					}
					this.$api.auctionGoodsPutaway({
						id: row.id
					}, res => {
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								message: '拍品上架成功',
								type: 'success',
								duration: 2000
							})
						}
					})
				}
				if (sign === 'soldout') {
					if (row.lotStatus == 0) {
						this.$message({
							message: '当前拍品已下架',
							type: 'error',
							duration: 2000
						})
						return
					}
					this.$api.auctionGoodsSoldOut({
						id: row.id
					}, res => {
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								message: '拍品下架成功',
								type: 'success',
								duration: 2000
							})
						}
					})
				}
				if (sign === 'record') {
					this.recordConfig.id = row.id
					this.recordConfig.currentPage = 1
					this.fetchRecord()
				}
				if (sign === 'deposit') {
					this.$router.push({
						path: '/earnest',
						query: {
							id: row.id
						}
					})
				}
				if (sign === 'search') {
					// this.info = row
					this.$api.auctionGoodsDetail({
						id: row.id
					}, res => {
						if(res.code==200){
							this.info = res.data
						}
					})
					this.checkFlag = true
				}
			},
			recordPageChange(e) {
				this.recordConfig.currentPage = e
				this.fetchRecord()
			},
			fetchData() {
				this.$api.commodityAuctionList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					relation: 1
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			},
			fetchRecord() {
				this.$api.auctionGoodsRecord({
					id: this.recordConfig.id,
					pageSize: this.recordConfig.pageSize,
					pageNum: this.recordConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.recordData = res.data.list
						this.recordConfig.total = res.data.total
						this.dialogVisible = true
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.dialog-pager {
		width: 100%;
		height: 70px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	.commodity-info{
		width: 100%;
		li{
			width: 100%;
			line-height: 40px;
			display: flex;
			align-items: flex-start;
			font-size: @vue-font-size-sm;
			.key{
				color: @vue-text-color-active;
				white-space: nowrap;
				padding-right: @vue-spacing-row-sm;
			}
			img{
				width: 94%;
				display: block;
			}
		}
	}
</style>
